// Auto-generated file - Do not edit manually
// Generated by MetaSKU/upload_carousel_images.py

// Carousel card image URLs from Google Cloud Storage
export const IMG_01_DEFAULT =
  "https://storage.googleapis.com/mattoboard-staging.appspot.com/design_stream/carousel_cards/01_BATHROOM_DEFAULT.png";
export const IMG_01_HOVER =
  "https://storage.googleapis.com/mattoboard-staging.appspot.com/design_stream/carousel_cards/01_BATHROOM_HOVER.png";
export const IMG_02_DEFAULT =
  "https://storage.googleapis.com/mattoboard-staging.appspot.com/design_stream/carousel_cards/02_BEDROOM_DEFAULT.png";
export const IMG_02_HOVER =
  "https://storage.googleapis.com/mattoboard-staging.appspot.com/design_stream/carousel_cards/02_BEDROOM_HOVER.png";
export const IMG_03_DEFAULT =
  "https://storage.googleapis.com/mattoboard-staging.appspot.com/design_stream/carousel_cards/03_LIVING%20ROOM_DEFAULT.png";
export const IMG_03_HOVER =
  "https://storage.googleapis.com/mattoboard-staging.appspot.com/design_stream/carousel_cards/03_LIVING%20ROOM_HOVER.png";
export const IMG_04_DEFAULT =
  "https://storage.googleapis.com/mattoboard-staging.appspot.com/design_stream/carousel_cards/04_CAFE_DEFAULT.png";
export const IMG_04_HOVER =
  "https://storage.googleapis.com/mattoboard-staging.appspot.com/design_stream/carousel_cards/04_CAFE_HOVER.png";
export const IMG_05_DEFAULT =
  "https://storage.googleapis.com/mattoboard-staging.appspot.com/design_stream/carousel_cards/05_KITCHEN_DEFAULT.png";
export const IMG_05_HOVER =
  "https://storage.googleapis.com/mattoboard-staging.appspot.com/design_stream/carousel_cards/05_KITCHEN_HOVER.png";
export const IMG_06_DEFAULT =
  "https://storage.googleapis.com/mattoboard-staging.appspot.com/design_stream/carousel_cards/06_RETAIL_DEFAULT.png";
export const IMG_06_HOVER =
  "https://storage.googleapis.com/mattoboard-staging.appspot.com/design_stream/carousel_cards/06_RETAIL_HOVER.png";
export const IMG_07_DEFAULT =
  "https://storage.googleapis.com/mattoboard-staging.appspot.com/design_stream/carousel_cards/07_OFFICE_DEFAULT.png";
export const IMG_07_HOVER =
  "https://storage.googleapis.com/mattoboard-staging.appspot.com/design_stream/carousel_cards/07_OFFICE_HOVER.png";
